// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.inputColumn .el-input__inner {\r\n  border: none;\r\n  text-align: center;\r\n  background: transparent;\r\n  padding: 0px;\r\n  margin: 0px;\n}\n.custom-table-change-header .vxe-header--row .vxe-cell {\r\n  height: 62px;\n}\r\n", ""]);
// Exports
module.exports = exports;
